import * as React from "react";
import { BaseIcon, BaseIconProps, BaseSVGIconProps } from "./BaseIcon";

const SvgLineHorizontalOne = ({
  color,
  alt,
  "aria-roledescription": roleDescription = "One Horizontal Line",
  ...restProps
}: BaseSVGIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="12"
    height="2"
    viewBox="0 0 12 2"
    fill="none"
    {...restProps}
  >
    <title>{alt}</title>
    {roleDescription ? <desc>{roleDescription}</desc> : null}
    <path
      d="M1 1H6H11"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const LineHorizontalOne = (props: BaseIconProps) => (
  <BaseIcon {...props}>
    <SvgLineHorizontalOne />
  </BaseIcon>
);

export default LineHorizontalOne;
